import React from 'react';

// Import images
import citroen from '../assets/images/voitures/citroen.jpeg';
import citroenC3 from '../assets/images/voitures/citroen_c3.jpeg';
import dacia from '../assets/images/voitures/dacia.jpeg';
import peugeot208 from '../assets/images/voitures/peugeot_208.jpeg';
import renaultClio5 from '../assets/images/voitures/renault_clio5.jpeg';
import utilitaireCitroen from '../assets/images/voitures/utilitaire_citroen.jpeg';
import utilitairePeugeot from '../assets/images/voitures/utilitaire_peugeot.jpeg';
import utilitairePeugeot2 from '../assets/images/voitures/utilitaire_peugeot2.jpeg';
import utilitairePeugeot3 from '../assets/images/voitures/utilitaire_peugeot3.jpeg';
import utilitaireRenault from '../assets/images/voitures/utilitaire_renault.jpeg';
import utilitaireRenault2 from '../assets/images/voitures/utilitaire_renault2.jpeg';
import utilitaireRenault3 from '../assets/images/voitures/utilitaire_renault3.jpeg';

const fleet = [
    { img: citroen, title: 'Citroën' },
    { img: citroenC3, title: 'Citroën C3' },
    { img: dacia, title: 'Dacia' },
    { img: peugeot208, title: 'Peugeot 208' },
    { img: renaultClio5, title: 'Renault Clio 5' },
    { img: utilitaireCitroen, title: 'Utilitaire Citroën' },
    { img: utilitairePeugeot, title: 'Utilitaire Peugeot' },
    { img: utilitairePeugeot2, title: 'Utilitaire Peugeot' },
    { img: utilitairePeugeot3, title: 'Utilitaire Peugeot' },
    { img: utilitaireRenault, title: 'Utilitaire Renault' },
    { img: utilitaireRenault2, title: 'Utilitaire Renault' },
    { img: utilitaireRenault3, title: 'Utilitaire Renault' },
];

const Fleet = () => {
    return (
        <div className="section container">
            <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
                <h1>Notre Flotte</h1>
                <p className="text-light" style={{ maxWidth: '600px', margin: '0 auto' }}>
                    Découvrez nos véhicules récents et entretenus pour assurer votre confort et votre sécurité lors de tous vos déplacements.
                </p>
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '2rem'
            }}>
                {fleet.map((car, index) => (
                    <div key={index} style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}>
                        <div style={{ height: '200px', overflow: 'hidden' }}>
                            <img
                                src={car.img}
                                alt={car.title}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    transition: 'transform 0.5s ease'
                                }}
                                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                            />
                        </div>
                        <div style={{ padding: '1rem' }}>
                            <h3 style={{ fontSize: '1.2rem', margin: 0 }}>{car.title}</h3>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Fleet;
